import { apiPrefix } from "./common";

import axios from "axios";

export default {
  apiProductRequests(site_id, path) {
    return apiPrefix(
      "/websites/" + site_id + "/product_requests" + (path ? "/" + path : "")
    );
  },

  getProductRequests(site_id, page, per_page, params) {
    return axios.get(this.apiProductRequests(site_id), {
      params: {
        page,
        per_page,
        ...params,
      },
    });
  },

  postProductRequest(site_id, form = {}) {
    return axios.post(this.apiProductRequests(site_id), form);
  },

  getProductRequest(site_id, product_request_id) {
    return axios.get(this.apiProductRequests(site_id, product_request_id));
  },

  putProductRequest(site_id, product_request_id, form = {}) {
    return axios.put(
      this.apiProductRequests(site_id, product_request_id),
      form
    );
  },

  deleteProductRequest(site_id, product_request_id) {
    return axios.delete(this.apiProductRequests(site_id, product_request_id));
  },
};
